import { axiosInstance } from './axiosInstance';
import { StatusCodes } from 'http-status-codes';

export const getOfferDetails = async ({ businessId, offerId }) => {
  const url = `/business-offers/${businessId}/offers/${offerId}`;

  const response = await axiosInstance.get(url);

  if (response.status !== StatusCodes.OK || !response.data) {

    throw new Error('GetOffersDetailsError');
  }

  return response.data;
};

export const getOffersList = async (businessId) => {
  const url = `/business-offers/${businessId}/offers`;
  const response = await axiosInstance.get(url);

  if (response.status !== StatusCodes.OK || !response.data) {

    throw new Error('GetOffersListError');
  }

  return response.data;
};

export const acceptOffers = async ({ businessId, offerId }) => {
  const url = `/business-offers/${businessId}/offers/${offerId}`;

  const response = await axiosInstance.post(url);

  if (response.status !== StatusCodes.ACCEPTED) {

    throw new Error('FailedToAcceptOffers');
  }

  return response.data;
};
